import React from 'react';
import Icon from '../common/Icon';

// Each position has its own pool so independently bouncing cards never
// display the same language at the same time.
const LANGUAGE_GROUPS = [
  ['Gujarati', 'Marathi', 'Punjabi'],
  ['English', 'Spanish', 'French'],
  ['Hindi', 'Urdu', 'Nepali'],
  ['Tamil', 'Telugu', 'Kannada'],
  ['German', 'Italian', 'Portuguese'],
  ['Bengali', 'Assamese', 'Odia'],
  ['Japanese', 'Korean', 'Chinese'],
  ['Malayalam', 'Arabic', 'Sanskrit'],
];

function LanguageCard({ languages, position }) {
  const [index, setIndex] = React.useState(0);

  return (
    <span
      className={`bouncing-language-card${position % 3 === 1 ? ' is-accent' : ''}`}
      style={{ '--bounce-delay': `${position * 0.24}s` }}
      onAnimationIteration={(event) => {
        if (event.target === event.currentTarget && event.animationName === 'languageCardBounce') {
          setIndex((current) => (current + 1) % languages.length);
        }
      }}
    >
      {languages[index]}
    </span>
  );
}

export default function BouncingLanguages() {
  return (
    <div
      className="bento-globe-pills-vis"
      role="img"
      aria-label={`Multilingual meetings across ${LANGUAGE_GROUPS.flat().join(', ')}.`}
    >
      <div className="bouncing-language-grid" aria-hidden="true">
        <div className="globe-glow-center">
          <Icon name="globe" size={32} />
        </div>
        {LANGUAGE_GROUPS.map((languages, position) => (
          <LanguageCard key={languages[0]} languages={languages} position={position} />
        ))}
      </div>
    </div>
  );
}
